export default "__VITE_ASSET__aa19f58a__"